import React from 'react';
import { Alert } from 'react-bootstrap';
import moment from 'moment';
import { strings } from '../../../resources/strings';
import { ErpOrder } from '../../../models/ErpOrder';
import { Table } from '../../../common-components/Table/Table';
import { Container } from './styles';

interface ITabFiscalProps {
    erpOrder?: ErpOrder|null;
}

export const TabFiscal: React.FC<ITabFiscalProps> = ({
    erpOrder
}) => {

    const nfes = React.useMemo(() => {
        const list = erpOrder?.erpNfes || [];

        if (list.length <= 0) return null;

        return (
            <Table>
                <thead>
                    <tr>
                        <th style={{width:'200px'}}>{strings.NFe}</th>
                        <th>{strings.Type}</th>
                        <th>{strings.Series}</th>
                        <th>{strings.Issue}</th>
                        <th>{strings.Canceled}/{strings.Returned}</th>
                    </tr>
                </thead>
                <tbody>
                    {list.map(nfe => {
                        return (
                            <tr key={`nfe-${nfe.id}`}>
                                <td>{nfe.nfeNumber}</td>
                                <td>{nfe.type}</td>
                                <td>{nfe.nfeSeries}</td>
                                <td>{`${nfe.issuedAtDate} ${nfe.issuedAtTime}`}</td>
                                <td>{nfe.isCancelled ? strings.Yes : strings.Not}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }, [ erpOrder ]);

    const nfces = React.useMemo(() => {
        const list = erpOrder?.erpNfces || [];

        if (list.length <= 0) return null;

        return (
            <Table>
                <thead>
                    <tr>
                        <th style={{width:'200px'}}>{strings.NFCe}</th>
                        <th>{strings.Type}</th>
                        <th>{strings.Series}</th>
                        <th>{strings.Issue}</th>
                        <th>{strings.Canceled}/{strings.Returned}</th>
                    </tr>
                </thead>
                <tbody>
                    {list.map(nfce => {
                        return (
                            <tr key={`nfce-${nfce.id}`}>
                                <td>{nfce.couponNumber}</td>
                                <td>{nfce.couponModel}</td>
                                <td>{nfce.couponSerie}</td>
                                <td>{moment(nfce.issueDate).format('DD/MM/YYYY HH:mm:ss')}</td>
                                <td>{nfce.isCancelled || nfce.isReturned ? strings.Yes : strings.Not}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }, [ erpOrder ]);

    return (
        <Container>
           {nfes || nfces || <Alert variant='warning'>Nenhum documento fiscal vinculado ao pedido até o momento.</Alert>}
        </Container>
    );
};